import { message } from 'antd';

function verifyResource(file: any, type: string): boolean {
  const fileExtension = file.name
    .split('.')
    .pop()
    .toLowerCase();

  let targetType: string[];
  if (type === 'ppt') targetType = ['ppt', 'pptx'];
  if (!targetType.includes(fileExtension)) {
    message.error(`请选择${type}类型的文档`);
    return false;
  }
  return true;
}

export { verifyResource };
